import {
  MessageTemplateDto,
  MustacheTemplateVariablesDto,
} from '@act/shared/data-transfer-objects';
import styled from 'styled-components';

export const Template = styled.div`
  padding: 8px;
  margin: 4px 0;
  border: 1px solid #eaeded;
  box-sizing: border-box;

  ${props =>
    props.onClick &&
    `&:hover {
    cursor: pointer;
    border: 1px solid #167e99;
  }`}
`;

interface TemplatesDisplayProps {
  handleApplyTemplate: (
    templateString: string,
    templateVariables: MustacheTemplateVariablesDto
  ) => void;
  templates: MessageTemplateDto[];
  templateVariables: MustacheTemplateVariablesDto;
}

const TemplatesDisplay = ({
  templates,
  handleApplyTemplate,
  templateVariables,
}: TemplatesDisplayProps) => {
  return (
    <>
      {templates.map(tmpl => {
        return (
          <Template
            key={`${tmpl.id}-${tmpl.categoryId}`}
            onClick={() =>
              handleApplyTemplate(tmpl.template, templateVariables)
            }
          >
            {tmpl.template}
          </Template>
        );
      })}
    </>
  );
};

export default TemplatesDisplay;
